module.exports = __webpack_public_path__ + "img/first_screen.5490167f.png";